import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const MyApi = ApiCore(globalDomains.MYAPI_AFREECATV);
export default MyApi;
